import React, { useEffect, useMemo, useState, useRef } from 'react';

import { Frame, Element, useEditor } from '@craftjs/core';

import Template from '@resolvers/pdf/Template/Template';
import TemplateEmail from '@resolvers/email/Template/TemplateEmail';
import {
  isTemplateTypePdfStyled,
  isTemplateTypeEmail,
  isTemplateTypePdfProgrammatic,
} from '@common/helpers/helpers';
import PageLayout from '@resolvers/pdf/Template/PageLayout';

import styles from './FrameEditor.module.scss';

const FrameEditor = ({
  jsonData,
  templateType,
  frameEditorRef,
  isCustomEmail,
  pageSize,
}) => {
  const [frameKey, setFrameKey] = useState(0);
  const ref = useRef(null);

  const { connectors } = useEditor();

  const currentTemplate = useMemo(() => {
    if (isTemplateTypeEmail(templateType))
      return <Element id='1' canvas is={TemplateEmail} />;

    if (isTemplateTypePdfStyled(templateType))
      return (
        <Element id='t1' pageSize={pageSize} canvas is={Template}>
          <PageLayout />
        </Element>
      );
    if (isTemplateTypePdfProgrammatic(templateType))
      return (
        <Element id='t2' pageSize={pageSize} canvas is={Template}>
          <PageLayout />
        </Element>
      );

    return undefined;
  }, [templateType]);

  useEffect(() => {
    if (ref?.current && connectors && frameKey) {
      connectors?.select(connectors?.hover(ref.current, null), null);
      frameEditorRef.current = ref.current;
    }
  }, [connectors, frameKey]);

  useEffect(() => {
    if (typeof jsonData === 'string' && templateType)
      setFrameKey((prev) => prev + 1);
  }, [jsonData, templateType]);

  return (
    currentTemplate && (
      <div
        className={`craftjs-renderer ${
          isCustomEmail
            ? styles.customEmailCraftContainer
            : styles.craftContainer
        }`}
        ref={ref}
      >
        {frameKey && (
          <Frame key={frameKey} data={jsonData}>
            {currentTemplate}
          </Frame>
        )}
      </div>
    )
  );
};

export default FrameEditor;
